import { render } from "./ClientDescription.vue?vue&type=template&id=be3fcf3c&scoped=true"
import script from "./ClientDescription.vue?vue&type=script&lang=ts"
export * from "./ClientDescription.vue?vue&type=script&lang=ts"

import "./ClientDescription.vue?vue&type=style&index=0&id=be3fcf3c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-be3fcf3c"

export default script